import axios, { peramalIntegratorInstance } from 'util/axiosConfig';

export const isIntegratorRunningAPI = () => {
    return peramalIntegratorInstance
        .get(`/api/v1/integratorRunning`)
        .then(function (response) {
            if (response.status == 200) {
                return response.data;
            }
            return false;
        })
        .catch(function (error) {
            return false;
        });
}

export const getPacsListAPI = () => {
    return axios
        .get(`/api/integrator/pacs`)
        .then(function (response) {
            if (response.status == 200) {
                return { success: true, data: response.data };
            }
            return { success: false, error: null };
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getPacsSessionIdAPI = (pacsId, username, pacsUser, clientId) => {
    return axios
        .get(`/api/integrator/createSessionID`, {
            params: {
                pacsId,
                username,
                pacsUser,
                clientId
            }
        })
        .then(function (response) {
            if (response.status == 200) {
                return { success: true, pacsSessionId: response.data };
            }
            return { success: false, error: null };
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const createSessionIdAPI = (username, pacsUser, clientId) => {
    return peramalIntegratorInstance
        .get(`/api/v1/createSessionID`, {
            params: {
                username,
                pacsUser,
                clientId
            }
        })
        .then(function (response) {
            if (response.status == 200) {
                return response.data;
            }
            return false;
        })
        .catch(function (error) {
            return false;
        });
}

export const loadUnloadOrderAPI = (data) => {
    return peramalIntegratorInstance
        .post(`/api/v1/loadUnloadOrder`, data)
        .then(function (response) {
            if (response.status == 200) {
                return response.data;
            }
            return false;
        })
        .catch(function (error) {
            return false;
        });
}

export const closeSessionAPI = (pacsBaseUrl,pacsUser, pacsSessionId) => {
    return peramalIntegratorInstance
        .get(`/api/v1/closeSession`, {
            params: {
                pacsBaseUrl,
                pacsUser,
                pacsSessionId
            }
        })
        .then(function (response) {
            if (response.status == 200) {
                return response.data;
            }
            return false;
        })
        .catch(function (error) {
            return false;
        });
}

export const downloadInstallerAPI = (installer) => {
    return peramalIntegratorInstance
        .get(`/api/v1/closeSession`, {
            params: {
                installer
            }
        })
        .then(function (response) {
            if (response.status == 200) {
                return response.data;
            }
            return false;
        })
        .catch(function (error) {
            return false;
        });
}